/**
 * debug.js — conditional verbose logging controlled by the "Debug Mode"
 * preference stored in localStorage('dawn.debugMode').
 *
 * Usage:
 *   import { debugLog } from '../utils/debug';
 *   debugLog('[ActivityTracker]', 'poll result', data);
 *
 * No-ops silently when debug mode is off.
 */

export const isDebugMode = () => localStorage.getItem('dawn.debugMode') === 'true';

export const debugLog = (...args) => {
  if (isDebugMode()) {
    console.log('[DAWN DEBUG]', ...args);
  }
};

export const debugWarn = (...args) => {
  if (isDebugMode()) {
    console.warn('[DAWN DEBUG]', ...args);
  }
};

export const debugError = (...args) => {
  if (isDebugMode()) {
    console.error('[DAWN DEBUG]', ...args);
  }
};

export const setDebugMode = (enabled) => {
  localStorage.setItem('dawn.debugMode', enabled ? 'true' : 'false');
};
